import {SystemMemoryProps} from "../../models/SystemMemoryProps";
import React, {useEffect, useState} from "react";
import {ContainerLoader} from "../loader/ContainerLoader";
import {ApiDataHelper} from "../../data/ApiDataHelper";
import {RenderPortfolioError} from "./PortfolioError";
import {PortfolioPaginatorModel} from "../../models/portfolio/PortfolioPaginatorModel";
import {Card, Grid, Group, Text, Badge, Tooltip} from "@mantine/core";

export function RenderPortfolioGrid(props: {
    rows: number,
    page: number,
    memory: SystemMemoryProps
}) {

    const [Content, setContent] = useState(<ContainerLoader />);

    async function FetchPortfolioData() {
        let api = new ApiDataHelper(props.memory);

        // Get the portfolio data from the API
        let data = undefined;
        try {
            data = await api.Execute<PortfolioPaginatorModel[]>(`/v1/portfolio/paginator/${props.page}`, {
                headers: {
                    'Accept': 'application/json',
                },
                method: 'GET'
            }, true, 30);
        }
        catch {

        }

        if (data !== undefined) {
            // If the data is not empty, render the portfolio grid
            if (data.length > 0) {
                // If rows = 1 then remove all but the first 3 items
                if (props.rows === 1) {
                    data = data.slice(0, 3);
                }

                // Render the portfolio grid with the data
                setContent(
                    <>
                    <br />
                    <Grid p="md">
                        {data.map((item) => (
                            <Grid.Col sm={4} xs={12}>
                                <Card shadow="sm" padding="lg" radius="md" withBorder style={{ border: `2px solid #${item.statusColour}95` }} h="100%">
                                    <Group mt="md" mb="xs" position="apart">
                                        <Text fw={500} size="xl">{item.name}</Text>
                                        <Group>
                                            {item.gitUrl && (
                                                <Tooltip label={item.gitUrl}>
                                                    <Badge
                                                        component="a"
                                                        href={item.gitUrl}
                                                        target="_blank"
                                                        sx={{ backgroundColor: "#6c94d280", color: "white" }}
                                                    >
                                                        Open Source
                                                    </Badge>
                                                </Tooltip>
                                            )}
                                            <Tooltip label={item.statusDescription}>
                                                <Badge
                                                    sx={{ backgroundColor: `#${item.statusColour}95`, color: "white" }}
                                                >
                                                    {item.status}
                                                </Badge>
                                            </Tooltip>
                                        </Group>
                                    </Group>
                                    <Text size="sm" color="dimmed" mt="sm" align="left">
                                        {item.description}
                                    </Text>
                                    <Group spacing="xs" mt="sm">
                                        {item.tags.map((tag) => (
                                            <Tooltip label={tag.description}>
                                                <Badge
                                                    component="a"
                                                    href={tag.documentation}
                                                    target="_blank"
                                                    sx={{
                                                        backgroundColor: `${tag.colourCode}95`,
                                                        color: "white",
                                                        display: "flex",
                                                        alignItems: "center"
                                                    }}
                                                >
                                                    {tag.name}
                                                </Badge>
                                            </Tooltip>
                                        ))}
                                    </Group>
                                </Card>
                            </Grid.Col>
                        ))}
                    </Grid>
                    </>
                );
            } else {
                // If the data is empty, render an empty state
                setContent(<RenderPortfolioError />);
            }
        } else {
            setContent(<RenderPortfolioError />);
        }
    }

    useEffect(() => {
        FetchPortfolioData()
    }, []);

    return (
        <>
        {Content}
        </>
    );
}